"use client";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { CookieBanner } from "./CookieBanner";
import { CookiePreferencesModal } from "./CookiePreferencesModal";
import { CookieFloatingButton } from "./CookieFloatingButton";
import { getStoredConsent, storeConsent, getDefaultConsent, setCookie, getCookie, getCookieDomain, SESSION_ID_KEY, getAllowedConsent, getDeniedConsent, updateSessionConsent, } from "../utils/cookieUtils";
import { sendEvent } from "../events/utils";
export function CookieManager({ config }) {
    const [consent, setConsent] = useState(getDefaultConsent());
    const [showBanner, setShowBanner] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [showFloatingButton, setShowFloatingButton] = useState(false);
    const allowedConsent = getAllowedConsent();
    const deniedConsent = getDeniedConsent();
    useEffect(() => {
        const storedConsent = getStoredConsent();
        if (storedConsent) {
            setConsent(storedConsent);
            setShowFloatingButton(true);
        }
        else {
            setShowBanner(true);
        }
    }, []);
    const handleConsentChange = (newConsent) => {
        setConsent(newConsent);
        storeConsent(newConsent);
        updateSessionConsent(newConsent.interactionType);
        config?.onConsentChange?.(newConsent);
    };
    const handleAcceptAll = (consent) => {
        handleConsentChange(consent);
        setShowBanner(false);
        setShowModal(false);
        setShowFloatingButton(true);
        setShowFloatingButton(true);
        updateSessionExpiry();
        config?.onConsentChange?.(consent);
    };
    const updateSessionExpiry = (action) => {
        const sessionId = getCookie(SESSION_ID_KEY);
        const isRestricted = getCookie("RestrictionRequired") == "true";
        const domain = getCookieDomain();
        setCookie(SESSION_ID_KEY, sessionId, action === "reject" ? undefined : isRestricted ? undefined : 100, domain);
    };
    const handleRejectAll = (consent) => {
        handleConsentChange(consent);
        setShowBanner(false);
        setShowModal(false);
        setShowFloatingButton(true);
        updateSessionExpiry("reject");
        config?.onConsentChange?.(consent);
    };
    const handleSaveSettings = (customConsent) => {
        handleConsentChange(customConsent);
        setShowBanner(false);
        setShowModal(false);
        setShowFloatingButton(true);
        updateSessionExpiry();
        sendEvent("popup_save_settings_button_clicked");
        config?.onConsentChange?.(customConsent);
    };
    const handleManagePreferences = () => {
        setShowModal(true);
        sendEvent("customize_button_clicked");
        config?.modalContext?.handleOpenModal?.("cookie-modal");
    };
    const handleModalClose = (open) => {
        setShowModal(false);
        if (!open)
            sendEvent("popup_close_button_clicked");
        config?.modalContext?.handleCloseModal?.();
    };
    const handleFloatingButtonClick = () => {
        setShowModal(true);
        sendEvent("cookie_consent_logo_clicked");
        config?.modalContext?.handleOpenModal?.("cookie-modal");
    };
    return (_jsxs(_Fragment, { children: [showBanner && (_jsx(CookieBanner, { onManagePreferences: handleManagePreferences, onAcceptAll: () => {
                    handleAcceptAll(allowedConsent);
                    sendEvent("consent_button_clicked");
                }, onRejectAll: () => {
                    handleRejectAll(deniedConsent);
                    sendEvent("reject_all_button_clicked");
                }, position: config?.position })), showFloatingButton && !showBanner && (_jsx(CookieFloatingButton, { onClick: handleFloatingButtonClick, position: config?.position })), _jsx(CookiePreferencesModal, { open: showModal, onOpenChange: handleModalClose, onSave: handleSaveSettings, onAcceptAll: handleAcceptAll, onRejectAll: handleRejectAll, consent: consent, setConsent: setConsent })] }));
}
